module.exports = __webpack_public_path__ + "img/IMG_6994.7d30df46.webp";